import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

loadFonts()

// Global fetch interceptor for auth errors
const originalFetch = window.fetch
window.fetch = async function(...args) {
  const response = await originalFetch(...args)
  
  // Check for authentication errors
  if (response.status === 401 || response.status === 403) {
    // Clear stored authentication data
    localStorage.removeItem('authToken')
    localStorage.removeItem('user')
    
    // Redirect to login
    router.push('/login')
  }
  
  return response
}

createApp(App)
  .use(router)
  .use(vuetify)
  .mount('#app')
